import React from 'react';
import MediaContent from '../components/MediaContent';

const Media = () => {
  return <MediaContent/>;
};

export default Media;
